<template>
<div class="contact_wrap">
    <div class="container">
      <section class="section contact-info pb-0">
      <div class="container">
           <div class="row">
              <div class="col-lg-4 col-sm-6 col-md-6" uk-scrollspy="cls: uk-animation-slide-left;delay:350">
                <a>  
                <div class="contact-block mb-4 mb-lg-0">
                   <i class="fas fa-phone-alt"></i>
                      <h5>{{get_local_string.string_49}}</h5>
                      <a :href="`tel:${get_setting_app.web_setting.phone}`">{{get_setting_app.web_setting.phone}} </a>
                                                
                  </div>
                </a>
              </div>
              <div class="col-lg-4 col-sm-6 col-md-6" uk-scrollspy="cls: uk-animation-slide-left;delay:650">
                <a> 
                  <div class="contact-block mb-4 mb-lg-0">
                    <i class="fas fa-envelope-open-text"></i>
                      <h5>{{get_local_string.string_50}}</h5>
                       <a :href="`mailto:${get_setting_app.web_setting.email}`">{{get_setting_app.web_setting.email}}</a>
                  </div>
                </a>
              </div>
              <div class="col-lg-4 col-sm-6 col-md-6" uk-scrollspy="cls: uk-animation-slide-left;delay:850">
                  <div class="contact-block mb-4 mb-lg-0">
                   <i class="fas fa-map-marked-alt"></i>
                      <h5>{{get_local_string.string_102}}</h5>
                      <a href="#">
                      {{get_setting_app.web_setting.address}}</a>
                  </div>
              </div>
          </div>
      </div>
  </section>
  
  <section class="contact-form-wrap section d-none" uk-scrollspy="cls: uk-animation-slide-top;delay:1000">
      <div class="container">
          <div class="row justify-content-center">
              <div class="col-lg-6">
                  <div class="section-title text-center">
                      <h2 class="text-md mb-2"> Send Oss en melding</h2>
                      <div class="divider mx-auto my-4"></div>
                  </div>
              </div>
          </div>
          <div class="row mt-4">
              <div class="col-lg-12 col-md-12 col-sm-12">
                  <form id="contact-form" class="contact__form " method="post" action="mail.php">
                   <!-- form message -->
                      <div class="row">
                          <div class="col-12">
                              <div class="alert alert-success contact__msg" style="display: none" role="alert">
                                  Your message was sent successfully.
                              </div>
                          </div>
                      </div>
  
                      <div class="row">
                          <div class="col-lg-6">
                              <div class="form-group">
                                  <input name="name" id="name" type="text" class="form-control" placeholder="Navn" >
                              </div>
                          </div>
  
                          <div class="col-lg-6">
                              <div class="form-group">
                                  <input name="email" id="email" type="email" class="form-control" placeholder="E-post"/>
                              </div>
                          </div>
                      </div>
  
                      <div class="form-group-2 mb-4">
                          <textarea name="message" id="message" class="form-control" rows="8" placeholder="Kommentar"></textarea>
                      </div>
  
                      <div class="text-center">
                          <input class="btn btn-main btn-round-full" name="" type="submit" value="SENDE INN"/>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </section>
  
   <div class="google-map">
    <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d882.4540460389846!2d10.338527477066874!3d63.35071890686537!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466d2e7e50fd00eb%3A0xd0b36ac8616ac63d!2sVerona%20Pizzeria!5e0!3m2!1sen!2sus!4v1649100455347!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe> -->
      <GmapMap ref="mapss"
      :center='center'
      :zoom='17'
      style='width:100%;  height: 400px;'
    >
      <GmapMarker
        :position="center"
        :draggable="false" 
        :icon="get_setting_app.web_setting.map_icon"
       
      />
      <!--     icon= "https://24order.no/storage/app/uploads/public/612/3fb/004/6123fb004e37b780670542.png" -->
    </GmapMap> 

  </div>


</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
        name:'contact-us',
        data(){
          return{
            center: { lat:0, lng: 0 },
          }
        },
        computed:{
            ...mapGetters({
                 get_setting_app:'get_setting_app',
                  get_local_string:'get_local_string'
            })
        },
        methods:{
        split_lang_lng(){
          let latlng = this.get_setting_app.web_setting.latlng;
          
         let arr_latlng = latlng.split(',');
           this.center.lat = arr_latlng[0]*1;
           this.center.lng = arr_latlng[1]*1;
           console.log(latlng ,arr_latlng[0]*1 , arr_latlng[1]*1);
        },
        },
       
        mounted(){
          this.split_lang_lng();
        }
    }
</script>
<style lang="scss" scoped>

.contact-block {
   text-align: center;
    border: 2px solid var(--active_color);;
    padding: 30px 25px;
    border-radius: 13px;
    color: var(--active_color);
    min-height: 230px;
    display: flex;
    background-color: #000000e6;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease-in-out;
    }
    // .contact-block:hover{
    //     background-color: #314e8c;
    //     color: white;
    // }
    // .contact-block:hover.contact-block i , .contact-block:hover.contact-block h5{
    //     color: white;

    // }
    
    .contact-block h5{
      margin: 10px;
      color: var(--active_color);
    }
    .contact-block a{
        color: var(--active_color);
    }
    .contact-info{
      padding-top: 80px;
      padding-bottom: 50px;
    }
    .contact-block i {
      font-size: 50px;
      margin-bottom: 15px;
      display: inline-block;
      color: var(--active_color);
    }
  
    .contact-form-wrap .form-group {
      margin-bottom: 20px;
    }
    
    .contact-form-wrap .form-group .form-control {
      height: 40px;
    border: 1px solid var(--active_color);
    box-shadow: none;
    width: 100%;
    background: #f5f5f5;
    color: white;
    }
    
    .contact-form-wrap .form-group-2 {
      margin-bottom: 13px;
    }
    
    .contact-form-wrap .form-group-2 textarea {
      height: auto;
      border: 1px solid var(--active_color);;
      box-shadow: none;
      background: #f5f5f5;
      width: 100%;
    }
    
    .social-icons li {
      margin: 0 6px;
    }
    
    .social-icons a {
      margin-right: 10px;
      font-size: 18px;
    }
    
    .google-map {
      margin-top: 40px;
      position: relative;
    }
    
    .google-map #map {
      width: 100%;
      height: 500px;
    }
    
    .mt-90 {
      margin-top: 90px;
    }
  
    .divider {
      width: 40px;
      height: 5px;
      background: var(--active_color);
      padding: 0;
      margin: 0;
      margin: 10px auto !important;
  }
  
  .btn-round-full {
      border-radius: 50px;
  }
  .section-title{
      color: var(--active_color);
      h2{
         color: var(--active_color);
        font-size: 24px;
        font-weight: 600;
      }
  }
  
  .btn-main {
      background: var(--active_color);
      color: var(--main_color);
      border-color: var(--active_color);
  }
  .btn-main:hover{
    color:var(--main_color);
     background: var(--active_color2);
  }
  .btn {
      display: inline-block;
      font-size: 14px;
      font-size: 0.8125rem;
      font-weight: 700;
      letter-spacing: .5px;
      padding: .75rem 2rem;
      font-family: "Exo", sans-serif;
      text-transform: uppercase;
      border-radius: 5px;
      border: 2px solid transparent;
      transition: all .35s ease;
  }
  
  .google-map iframe{
    width: 100%;
    margin-top: 40px;
  }
</style>